export default "__VITE_ASSET__DNL9UhcM__"